import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { lazy, useMemo } from 'react';

import PublicLayout from './public-layout.tsx';

import ErrorPage from './error-page.tsx';

export const PdfTestScoreReportPage = lazy(
  () => import('./pdf-test-score-report-page'),
);
export const PdfTestAnswerReportPage = lazy(
  () => import('./pdf-test-answer-report-page'),
);

import { PublicRoutesEnum } from '../utils/enums.ts';

const userRouter = () => {
  return createBrowserRouter([
    {
      element: <PublicLayout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: PublicRoutesEnum.PUBLIC_TEST_ATTEMPT_ATTEMPT_ID_SCORE_REPORT,
          element: <PdfTestScoreReportPage />,
        },
        {
          path: PublicRoutesEnum.PUBLIC_TEST_ATTEMPT_ATTEMPT_ID_ANSWER_REPORT,
          element: <PdfTestAnswerReportPage />,
        },
      ],
    },
  ]);
};

export const PublicRouterProvider = () => {
  const router = useMemo(() => userRouter(), []);

  return (
    <RouterProvider router={router} fallbackElement={<div>Loading…</div>} />
  );
};
